import type { TeamAppModel } from "../../hooks/teamTypes";
import { DefenseExportScreen } from "../defense/DefenseExportScreen";
import { DefenseScreen } from "../defense/DefenseScreen";

interface DefenseRouteProps {
  model: TeamAppModel;
  onPrint: () => void;
}

export function DefenseRoute({ model, onPrint }: DefenseRouteProps) {
  const { shell, defense } = model;
  const showEditor =
    shell.screen === "defense" ||
    (shell.screen === "defexport" && !defense.defense?.length);

  if (showEditor) {
    return (
      <DefenseScreen
        players={defense.players}
        activePlayers={defense.activePlayers}
        preferences={defense.preferences}
        defense={defense.defense}
        selectedInning={defense.selectedInning}
        gamePitcher={defense.gamePitcher}
        hasActiveGame={defense.hasActiveGame}
        actionStatus={defense.actionStatus}
        onBack={() => shell.setScreen(defense.hasActiveGame ? "game" : "setup")}
        onSetPitcher={defense.actions.setPitcher}
        onGenerate={
          shell.screen === "defexport"
            ? () => {
                const request = defense.actions.regenerate();
                shell.setScreen("defense");
                void request;
              }
            : defense.actions.regenerate
        }
        onShowExport={() => shell.setScreen("defexport")}
        onSelectInning={defense.setSelectedInning}
        onAssign={defense.actions.setManualAssign}
      />
    );
  }

  return (
    <DefenseExportScreen
      teamName={defense.teamName}
      players={defense.players}
      preferences={defense.preferences}
      defense={defense.defense ?? []}
      view={defense.exportView}
      fieldInning={defense.fieldInning}
      onChangeView={defense.setExportView}
      onSelectFieldInning={defense.setFieldInning}
      onPrint={onPrint}
      onBack={() => shell.setScreen("defense")}
    />
  );
}
